module.exports = __webpack_public_path__ + "img/title6.2507c73c.png";